module.exports = __webpack_public_path__ + "img/Wagenburg_ith_Ramp_up.c237af16.gif";